import React from 'react';
import { useParams } from 'react-router-dom';
import MyBookingsPageContent from './content';
import { PageContextProvider } from './context';

const MyBookingsPage = () => {
  const { virtualPhoneNumber } = useParams();
  return (
    <PageContextProvider virtualPhoneNumber={virtualPhoneNumber}>
      <MyBookingsPageContent />
    </PageContextProvider>
  );
};

export default MyBookingsPage;
